<script>
	import Navbar from './components/Navbar.svelte';

</script>

<Navbar />

<div class='d-flex justify-content-center mt-5'>
    <svg width="25%" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M167.764 122.509C193.057 105.756 223.389 96 256 96C344.366 96 416 167.634 416 256C416 288.611 406.244 318.943 389.491 344.236L167.764 122.509ZM122.509 167.764C105.756 193.057 96 223.389 96 256C96 344.366 167.634 416 256 416C288.611 416 318.943 406.244 344.236 389.491L122.509 167.764ZM256 32C132.288 32 32 132.288 32 256C32 379.712 132.288 480 256 480C379.712 480 480 379.712 480 256C480 132.288 379.712 32 256 32Z" fill="#dc3545"/>
    </svg>
</div>

<h1 class='text-center text-danger fw-bold'>Sin permisos</h1>
